<template>
	<form id="mfa-recovery-form" @submit.prevent="handleSubmit(recoveryText)" :key="stateChangeKey">
		<div class="w-100 mt-3 mb-4 text-center">
			<div class="d-flex-column justify-content-left mb-3 mt-3">
				<textarea
					v-model.trim="recoveryText"
					class="form-group form-control styled-input"
					:class="{ error: hasError }"
					placeholder="Paste or type your recovery code"
					@change="$emit('resetErrors')"
					name="recovery-text-input"
				></textarea>
			</div>
			<div class="w-100 para-3 error-text" v-if="hasError || warning">
				<span v-if="hasError" class="text-bold error-message"><i></i>{{ error[0] }}</span>
				<span v-if="warning" :style="{ color: warningColor }"><br v-if="hasError" /><i></i>{{ warning }}</span>
			</div>
		</div>
		<AppButton
			:name="submitButtonName"
			class="w-100 mb-2"
			:disabled="recoveryText.trim().length == 0 || isLoading"
			type="submit"
			size="medium"
			:data-target="dataTarget"
			:loading="isLoading"
		>
			{{ submitButtonText }}
		</AppButton>
		<div v-if="showHelpAndRecovery" class="help-section">
			<!-- Fire event to show modal -->
			<p class="modal-pretext text-light text-center"><a class="button-color" @click="openOTPInputModal">Go Back</a></p>
			<!-- Link to help desk -->
			<p class="modal-pretext text-light text-center">Or <a class="button-color" @click="openHelpPageInNewTab">get help</a></p>
		</div>
	</form>
</template>

<script>
	export default {
		name: 'RecoveryTextInput',
		props: {
			placeholder: {
				type: String,
				default: '',
			},
			error: {
				type: Array,
				default: () => [],
			},
			warning: {
				type: String,
				default: '',
			},
			warningColor: {
				type: String,
				default: '#00cfcc',
			},
			stateChangeKey: {
				type: Number,
				default: 0,
			},
			dataTarget: {
				type: String,
				default: '#mfa-configuration-modal',
			},
			submitButtonName: {
				type: String,
				default: 'mfa-recovery-button',
			},
			submitButtonText: {
				type: String,
				default: 'Continue',
			},
			showHelpAndRecovery: {
				type: Boolean,
				default: true,
			},
			helpButtonName: {
				type: String,
				default: 'mfa-need-help',
			},
			helpButtonText: {
				type: String,
				default: 'Need help?',
			},
			loading: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				recoveryText: '',
				buttonIsLoading: this.loading,
			}
		},
		computed: {
			hasError() {
				return this.error && this.error.length
			},
			isLoading() {
				return this.buttonIsLoading
			},
		},
		methods: {
			openHelpPageInNewTab() {
				window.open('https://help.stan.store/article/410-2fa-help', '_blank')
			},
			openOTPInputModal() {
				this.$emit('showOTP')
			},
			handleSubmit(code) {
				this.buttonIsLoading = true
				this.$emit('submit', code)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.otp-inputs {
		display: flex;
		justify-content: space-between;
		width: 95%;
		margin: 0px auto;

		@media (max-width: 767px) {
			max-width: 250px;
		}

		input {
			width: 55px;
			height: 70px;
			font-size: 40px;
			font-weight: 600;
			color: var(--stan-primary-primary-color);
			text-align: center;
			border: 1.5px solid var(--stan-primary-soft-color);
			border-radius: 8px;
			outline: none;
			transition: border-color 0.3s;
			@media (max-width: 767px) {
				width: 35px;
				height: 45px;
				font-size: 25px;
				// Override default style sheet onm safari that adds ~15px padding on the x axis
				padding: 1px 2px 1px 2px;
			}
		}

		input:focus {
			box-shadow: 0px 0px 0px 4px var(--stan-primary-soft-color), 0px 0px 0px 4px var(--stan-primary-soft-color) !important;
		}
	}

	.error-text {
		font-size: 13px;
		font-style: normal;
		line-height: normal;
		letter-spacing: -0.26px;
		padding-top: 6px;
		padding-left: 6px;
	}

	.error {
		color: var(--stan-text-dark-color) !important;
		background-color: var(--stan-negative-light-color) !important;
	}

	.error-message {
		color: var(--stan-text-negative-color) !important;
	}

	.button-color {
		color: var(--stan-primary-primary-color);
	}

	.help-section {
		padding-top: 20px;
	}
	.styled-input {
		resize: none;
		height: 70px;
		&:focus {
			outline: none;
		}
		&:disabled {
			cursor: not-allowed;
			color: var(--stan-text-light-color) !important;
			background: var(--stan-primary-light-color) !important;
			-webkit-text-fill-color: var(--stan-text-light-color);
			-webkit-opacity: 1;
		}
	}
	textarea {
		// Account for border and box-shadow when using focus
		background: #fff;
		border: 1px solid var(--stan-gray-strike-color);
		color: var(--stan-primary-primary-color);
		width: calc(100% - 10px);
		// Margin to account for box shadow on focus
		margin-left: 5px;

		textarea:focus {
			box-shadow: 0px 0px 0px 4px var(--stan-primary-soft-color), 0px 0px 0px 4px var(--stan-primary-soft-color) !important;
		}
	}

	textarea::placeholder {
		color: var(--stan-gray-dark-color-ada) !important;
	}
</style>
